import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildNetherShrine: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);

    brush.column(0, 2, 0, 4, BLOCK.Obsidian);
    brush.column(4, 2, 0, 4, BLOCK.Obsidian);
    brush.lineX(0, 4, 4, 2, BLOCK.Obsidian);

    const pillars: [number, number, number][] = [
        [0, 0, 3],
        [4, 0, 2],
        [0, 4, 2],
        [4, 4, 3],
    ];
    for (const [dx, dz, height] of pillars) {
        brush.column(dx, dz, 0, height - 1, BLOCK.Netherrack);
        brush.block(dx, height, dz, BLOCK.Glowstone);
    }
    brush.layer(1, 3, 0, 1, 0, BLOCK.Obsidian);

    brush.block(2, 1, 1, BLOCK.Glowstone);
    brush.block(1, 1, 0, BLOCK.Lava);
    brush.block(3, 1, 0, BLOCK.Lava);
};
